<div
    class="agpr-dateQueryInput u-mdPadding ui-inputgroup"
    [ngClass]="{
        'agpr-dateQueryInput--socialPlus': style === agprComponentStyle.socialPlus,
        'agpr-dateQueryInput--disabled': disabled
    }"
    role="group"
    [attr.aria-labelledby]="ariaLabelledBy"
>

    @if (useDateSearchRangeSelection) {
        <button
            [id]="id + '_dropdownButton'"
            [disabled]="disabled"
            type="button"
            class="agpr-dateQueryInput-button"
            [ngClass]="{ 'agpr-dateQueryInput-button--disabled': disabled}"
            [agprTooltip]="toolTipLabel | localize"
            tooltipPosition="top"
            [attr.aria-label]="(toolTipLabel ? toolTipLabel : 'openDateRangeSelection') | localize"
            [attr.aria-describedby]="id + '_textInput'"
            (click)="open()"
        >
            <span
                class="fa-duotone fa-regular fa-calendar-range"
                aria-hidden="true"
            ></span>
        </button>
    }
    <div class="agpr-dateQueryInput-dropdown">
        <agpr-dropdown
            #dropdown
            [id]="id + '_dateQueryInput_dropdown_' + (dropdownValue?.label || inputPlaceholder)"
            [options]="options"
            [ariaLabel]="'dateRangeDropdownSelector' | localize"
            key="type"
            [disabled]="disabled"
            [ngModel]="dropdownValue"
            [placeholder]="inputPlaceholder"
            [inputTooltip]="customOptionSelected ? dropdownValue.label : null"
            [infoCircleTooltip]="dropdownInfoTooltip"
            (ngModelChange)="dropdownSelectionChanged($event)"
        ></agpr-dropdown>
    </div>
</div>

